export default {"src":"/_next/static/media/icon-flag-philippine.420ff4d4.svg","height":27,"width":40,"blurWidth":0,"blurHeight":0};